module.exports = __webpack_public_path__ + "static/media/avon_grow.1f84381c.svg";